import React from 'react';

const FlowChartStatusBar = ({ saveStatus, isDesignMode, showCodeEditor, selectedShape }) => {
  return (
    <div
      style={{
        background: '#007acc',
        height: 22,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 12px',
        fontSize: 11,
        color: 'white',
      }}
    >
      <div>
        <span>🟢 Ready</span>
        {saveStatus && (
          <span style={{ marginLeft: 16 }}>
            {saveStatus.type === 'success' ? '✓' : '✗'} {saveStatus.message}
          </span>
        )}
      </div>
      <div style={{ display: 'flex', gap: 16 }}>
        <span>Design Mode: {isDesignMode ? 'ON' : 'OFF'}</span>
        <span>Code Editor: {showCodeEditor && selectedShape ? 'OPEN' : 'CLOSED'}</span>
      </div>
    </div>
  );
};

export default FlowChartStatusBar;
